module.exports = __webpack_public_path__ + "static/media/18_Garden_Sectoe_A_new.6e713783.jpg";